const KEY='lotq:cashback-return';
export function rememberCashbackBrand(id){
 if(!/^\d{1,12}$/.test(String(id)))return;
 try{localStorage.setItem(KEY,JSON.stringify({id:String(id),expires:Date.now()+86400000}));}catch{}
}
export function cashbackReturnPath(){
 try{const value=JSON.parse(localStorage.getItem(KEY));return value?.expires>Date.now()&&/^\d{1,12}$/.test(value.id)?`/cashback?marca=${value.id}`:null;}catch{return null;}
}
export function clearCashbackReturn(){try{localStorage.removeItem(KEY);}catch{}}
